import { type FileInfo, type Locale, Widget, type WidgetAPI } from '@uploadcare/react-widget'
import { type ReactElement, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const UploadImageButton = ({ onFinish }: { onFinish: (x: string) => void }): ReactElement => {
  const { i18n } = useTranslation()
  // eslint-disable-next-line @eslint-react/naming-convention-ref-name -- unicorn/name-replacements と両立する名前がないため、「〜Reference」にする
  const widgetApiReference = useRef<WidgetAPI>(null)

  const onImageUploaded = (fileInfo: FileInfo): void => {
    if (fileInfo.cdnUrl !== null) {
      onFinish(fileInfo.cdnUrl)
    }
    // アップロード後に「画像を選択」ボタンを再表示する: https://community.uploadcare.com/t/how-to-reset-widget-when-upload-is-complete/984
    widgetApiReference.current?.value(null)
  }

  return (
    <Widget
      ref={widgetApiReference}
      publicKey={process.env.UPLOADCARE_API_KEY ?? ''}
      locale={
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        i18n.language as Locale
      }
      imagesOnly={true}
      crop="150x150" // オリジナル画像が150x150でクロップされるわけではなく、レスポンスのCDN URLに150x150のURLが入った状態になるだけ
      onChange={onImageUploaded}
    />
  )
}
